import {
  BookOpen,
  BriefcaseBusiness,
  Gift,
  GraduationCap,
  Heart,
  Home,
  ListTodo,
  Plane,
  ShoppingCart,
} from 'lucide-react';
import { cn } from '../../lib/cn';

const iconMap = {
  cart: {
    label: 'Cart',
    component: ShoppingCart,
  },
  'list.bullet': {
    label: 'List',
    component: ListTodo,
  },
  house: {
    label: 'Home',
    component: Home,
  },
  briefcase: {
    label: 'Work',
    component: BriefcaseBusiness,
  },
  gift: {
    label: 'Gift',
    component: Gift,
  },
  graduationcap: {
    label: 'School',
    component: GraduationCap,
  },
  airplane: {
    label: 'Travel',
    component: Plane,
  },
  book: {
    label: 'Reading',
    component: BookOpen,
  },
  heart: {
    label: 'Health',
    component: Heart,
  },
};

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
};

export function getCollectionIconMeta(icon) {
  return iconMap[icon] || iconMap['list.bullet'];
}

function CollectionIcon({ icon, size = 'md', className, strokeWidth = 2 }) {
  const meta = getCollectionIconMeta(icon);
  const Icon = meta.component;

  return (
    <Icon
      aria-hidden="true"
      className={cn(sizeClasses[size] || sizeClasses.md, className)}
      strokeWidth={strokeWidth}
    />
  );
}

export default CollectionIcon;
